import { gql } from '@apollo/client';

export const GET_LOADING_ORDER_DETAIL_WAYPOINT_COUNT_BY_TASK_ID_AND_WAYPOINT_ID_FOR_PORTAL = gql`
    query GetLoadingOrderDetailWaypointCountByTaskIdAndWaypointIdForPortal($taskId: Long!, $waypointId: Long!) {
        getLoadingOrderDetailWaypointCountByTaskIdAndWaypointIdForPortal(taskId: $taskId, waypointId: $waypointId) {
            waypointId
            parcelCount
            bagCount
        }
    }
`;

export interface TmsWaypointOrderDetailCountType {
    waypointId: number;
    parcelCount: number;
    bagCount: number;
}

export interface GetLoadingOrderDetailWaypointCountByTaskIdAndWaypointIdForPortalResponse {
    getLoadingOrderDetailWaypointCountByTaskIdAndWaypointIdForPortal: TmsWaypointOrderDetailCountType | null;
}

export interface GetLoadingOrderDetailWaypointCountByTaskIdAndWaypointIdForPortalVariables {
    taskId: number;
    waypointId: number;
}
